<template>
  <div class="row">
    <div class="col-12">
      <form role="form">
        <div
          v-for="(banner,i) in banners"
          :key="i"
        >
          <div class="form-group row">
            <h2 class="pl-4 col-sm-2 col-form-label">
              {{ banner.lang }}
            </h2>
          </div>
          <div class="form-group row">
            <label class="pl-4 col-sm-2 col-form-label">{{
              $t("category")
            }}</label>
            <div class="col-sm-10">
              <label class="w-100">
                <select
                  name="category"
                  style="width: 100%"
                  class="form-control"
                  v-model="banner.categories_ids"
                  v-validate="'required'"
                >
                  <option
                    v-for="(type, i) in categories"
                    :value="type.id"
                    :key="i"
                  >
                    {{ type.name }}
                  </option>
                </select>
                <small v-show="errors.has('banner')" class="text-danger">
                  {{ $t("field_required") }}
                </small>
              </label>
            </div>
          </div>
          <div class="form-group row">
            <label class="pl-4 col-sm-2 col-form-label">{{
              $t("parameter")
            }}</label>
            <div class="col-sm-10">
              <label class="w-100">
                <select
                  name="banner"
                  style="width: 100%"
                  class="form-control"
                  v-model="banner.parameters_ids"
                  v-validate="'required'"
                >
                  <option
                    v-for="(type, i) in parameters"
                    :value="type.id"
                    :key="i"
                  >
                    {{ type.value }}
                  </option>
                </select>
                <small v-show="errors.has('banner')" class="text-danger">
                  {{ $t("field_required") }}
                </small>
              </label>
            </div>
          </div>
          <div class="form-group row">
            <div class="pl-4 col-sm-2 col-form-label">
              <img
                  v-if="banner.image_url !== '' && banner.image_url !== null"
                  class="img-fluid"
                  style="max-height: 130px"
                  :src="`${banner.image_url}`"
                />
            </div>
            <div class="col-sm-10">
              <label class="w-100">
                <input-file
                    ref="inputNailImg"
                    :inputData.sync="banner.image_url"
                    :prefix="`https://vnfr.cosmogroup.pl/assets`"
                    :label="$t('nail_image')"
                    :urlUploadFile="urlUpdateFile()"
                    name="product_nail_image_url"
                    @loading="updateFileLoading"
                ></input-file>
                <small v-show="errors.has('banner')" class="text-danger">
                  {{ $t("field_required") }}
                </small>
              </label>
            </div>
          </div>
          <div class="hr-line-dashed"></div>
        </div>
      </form>
      <div class="col-sm-12">
        <div
          type="submit"
          class="
            btn
            mx-md-2
            my-2
            btn-primary
            d-block d-md-inline-block
            float-md-right
          "
          v-text="
            editModel ? this.$t('update_parameter') : this.$t('save_parameter')
          "
          @click.prevent="saveParam()"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import InputFile from '@/components/InputFile'

export default {
  name: 'BannersForm',
  components: {
    InputFile
  },
  data() {
    return {
      defaultLangs: [ 'pl', 'en', 'de', 'es', 'fr', 'it' ],
      editModel: false,
      categories: [],
      parameters: [],
      banners: [ {
        id: '',
        image_url: '',
        parameters_ids: '',
        categories_ids: '',
        lang: ''
      } ],
      types_id: [],
      langsFormData: []
    }
  },
  created() {
    this.$emit( 'loading', true )
    Promise.all( [
      this.getCategoryList(),
      this.getProductsList(),
      this.getData()
    ] ).then( () => {
      this.$emit( 'loading', false )
    } )
    // this.createdLangsFormData();
    // this.$emit( 'loading', false )
  },
  methods: {
    urlUpdateFile() {
      return `vnfr/${this.$route.params.env}/banners/file`
    },
    updateFileLoading( loading ) {
      this.$emit( 'loading', loading )
    },
    getCategoryList() {
      this.$emit( 'loading', true )
      return this.$http
        .get( `vnfr/${this.$route.params.env}/categories/select-list` )
        .then( resp => {
          this.categories = resp.data.data
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    getProductsList() {
      this.$emit( 'loading', true )
      return this.$http
        .get(
          `vnfr/${this.$route.params.env}/parameters/select-list?parameter_type_id=4`
        )
        .then( resp => {
          this.parameters = resp.data.data
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    getData() {
      this.$emit( 'loading', true )
      return this.$http
        .get(
          `vnfr/${this.$route.params.env}/banners/${this.$route.params.id}`
        )
        .then( resp => {
          this.banners = resp.data.banners
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    createdLangsFormData() {
      this.defaultLangs.forEach( lang => {
        const elementIndex = this.parameter.lang.findIndex( element => element.lang == lang )
        if ( elementIndex !== -1 ) {
          this.langsFormData.push( this.parameter.lang[ elementIndex ] )
        } else {
          this.langsFormData.push( this.createDefaultLangsData( lang ) )
        }
      } )
    },
    createDefaultLangsData( lang ) {
      return {
        id: null,
        lang: lang,
        value: ''
      }
    },
    saveParam() {
      this.$validator.validateAll().then( result => {
        if ( result ) {
          this.$emit( 'loading', true )
          const url = `vnfr/${this.$route.params.env}/banners/${this.$route.params.id}`
          this.$http( {
            url:
              this.$route.params.id !== undefined
                ? url
                : `vnfr/${this.$route.params.env}/banners/`,
            method: this.$route.params.id !== undefined ? 'put' : 'post',
            data: {
              banners: this.banners
            }
          } )
            .then( resp => {
              this.$toastr.success( 'Zapisane!!' )
              this.$emit( 'loading', false )
              this.$router.push(
                `/przymierzalnia/${this.$route.params.env}/banners`
              )
            } )
            .catch( err => {
              this.$toastr.error( err )
              this.$emit( 'loading', false )
            } )
        }
      } )
    }
  }
}
</script>

<style scoped>
a {
  color: white;
}
.text-md {
  font-size: 14px;
}
</style>
